var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pending)?_c('div',{staticClass:"loading"},[_c('v-progress-linear',{attrs:{"height":"2","color":"accent","indeterminate":""}})],1):_c('div',[_vm._v("\n  "+_vm._s(_vm.value || '—')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }